import axiosClient from "./axiosClient";

const ClientAPI = {
  register: (data) => {
    const url = `clients`;
    return axiosClient.post(url, data);
  }
};

export default ClientAPI;
